export const PROFILE_PHOTO_FOLDER = 'avatar';

export const CHAT_FILE_FOLDER = 'chat';

export const CHAT_LIMIT = 30;

export const VISIT_STATUS = {
  COMPLETE: 'COMPLETED',
  PENDING: 'PENDING',
  UNANSWERED: 'IN-PROGRESS',
};

export const TRANSITION_TO_PAY_COMPANIES = [
  '9d4e796b-d943-4379-a689-785aaa796b59',
  '3b417796-6fd5-4951-832f-a42a361be710',
  '7632eee2-919c-40d2-b0bd-695f4a0064fa',
  'f647eeef-cf57-47f2-9440-b3f912a8da31',
  'b1270a81-f017-46fa-b4d0-63f56e40a482',
  '090ea02f-988c-457d-ad0c-aa5f70a66d91',
  '115f927f-bbd7-4213-b8c4-f96b82afb2e0',
  'a97b9271-b618-4ae8-b60c-99b678eccbff',
  '674a5243-df54-48b8-b755-953bbe200332',
  // '9de7d06c-5f75-4033-8e68-988b1eec56dd', // TEst company
  // '9e6c52f9-dcab-4dfc-8acc-a333343052fd', // TEst company 1
  // '9e6c5308-7563-4d7d-a03f-605ced01d9f6', // TEst company 2
  // '9e6c533f-f080-4efb-aa0e-25e212f166a4', // TEst company 3
  // '9e6c5318-108a-44a0-8adb-2a9e99639c44', // TEst company 4
  // '9e6c532c-6b39-49a0-8feb-bee46f06ffc6', // TEst company 5
];
